module.exports = __webpack_public_path__ + "img/ajoure.374ad9c.svg";